/** Colours for marks on the board, shared by the games and the website's demos. */
export const boardColors = {
  typed: 'color-mix(in srgb, var(--color-typed) 70%, transparent)',
  lastMove: 'rgb(205 210 106 / 0.55)',
  hint: '#3b82f6',
  right: 'var(--color-correct)',
  wrong: 'var(--color-incorrect)',
}
